import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import successAnim from "../assets/success-interaction.lottie";
import appStore from "../assets/images/app-store.png";
import playStore from "../assets/images/play-store.png";
import appStoreDark from "../assets/images/apple-dark.png";
import playStoreDark from "../assets/images/google-dark.png";

const APP_STORE_URL = "https://apps.apple.com/us/app/legal-platform/id6475202489";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.app.legalplatform&hl=en";

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);



    // Event snippet for Submit lead form conversion page
    const script = document.createElement("script");
    script.id = "lead-conversion-snippet";
    script.text = `gtag('event', 'conversion', { 'send_to': 'AW-18205272591/qyYWCMXehL8cEI_U-ehD', 'value': 1.0, 'currency': 'AED' });`;
    document.head.appendChild(script);

    return () => {
      document.getElementById("lead-conversion-snippet")?.remove();
    };

  }, []);

  return (
    <>
      <Seo
        title="Thank You — Legal Platform"
        description="Thank you for registering with Legal Platform. Our team will review your application and get back to you shortly."
        canonicalPath={process.env.REACT_APP_BASE_PATH + "/thank-you"}
        image="/favicon.png"
        noindex
      />
      <div className="privacy-bg from-top">
        <Header />
        {/* <div className="heading-policy flex-column">
          <h1>Thank You</h1>
        </div> */}
      </div>
      <Breadcrumbs />

      <div className="container data-info">
        <div className="text-center pb-5">
          <div style={{ width: "320px", height: "320px", margin: "-70px auto" }}>
            <DotLottieReact src={successAnim} autoplay />
          </div>
          <h2 className="fw-bold mt-3" style={{ color: "#1a1a1a" }}>
            Thank You for Registering!
          </h2>
          <p className="text-muted fs-5 mt-3 mb-4 mx-auto" style={{ maxWidth: "600px" }}>
            Your application has been submitted successfully. Our team will review your details and notify you by
            email once your account is approved. Meanwhile, download the Legal Platform app to be ready to receive
            clients.
          </p>

          <h5 className="fw-semibold mb-3" style={{ color: "#1a1a1a" }}>
            Download the App
          </h5>
          <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap mb-4">
            {/* Light mode badges; dark-mode.css swaps in the dark versions. */}
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store" >
              <img src={appStoreDark} alt="App Store" className="store-badge  hover-scale" />
            </a>
            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play" >
              <img src={playStoreDark} alt="Google Play" className="store-badge  hover-scale" />
            </a>
          </div>

          <Link to="/" className="fw-semibold text-dark text-decoration-underline">
            Back to Home
          </Link>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ThankYou;
